module.exports = __webpack_public_path__ + "images/tutorial_d.webp";